<template>
  <div class="auth-callback">
    <div v-if="store.isLoading" class="text-center">
      <div class="spinner-border" role="status"></div>
      <p class="mt-3">Autenticazione in corso...</p>
    </div>

    <div v-else-if="store.authError" class="text-center">
      <h3>Errore di autenticazione</h3>
      <p>{{ store.authError }}</p>
      <button class="btn btn-primary mt-2" @click="router.push('/')">
        Torna alla Home
      </button>
    </div>

    <div v-else class="text-center">
      <div class="spinner-border" role="status"></div>
      <p class="mt-3">Accesso riuscito, caricamento...</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore } from '../stores/app.js'

const store = useAppStore()
const router = useRouter()

onMounted(async () => {
  await store.resolveCodeOAuth2()
  if (!store.authError) {
    const redirect = localStorage.getItem('post_login_redirect')
    localStorage.removeItem('post_login_redirect')
    if (redirect && !redirect.includes('/auth/callback')) {
      window.location.href = redirect
    } else {
      router.push('/')
    }
  }
})
</script>

<style scoped>
.auth-callback {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}
</style>
